__turbopack_context__.v({
  "imageContainer": "SimpleImageUpload-module-scss-module__vsM_FW__imageContainer",
  "imageContainerAspectRatio": "SimpleImageUpload-module-scss-module__vsM_FW__imageContainerAspectRatio",
});
